import * as React from "react"
import { toPersianMoney } from "utils"
import classNames from "classnames"
import "./price.scss"

interface Price extends React.HTMLProps<HTMLSpanElement> {
	symbool?: boolean
	discount: string | number
	children: string | number
	discountSymbool?: boolean
}

const Price: React.FC<Price> = ({
	children,
	className,
	symbool = false,
	discount,
	discountSymbool = false,
}) => {
	return (
		<span className={classNames("price", className)}>
			{discount && (
				<span className="price--discount">
					{toPersianMoney(discount)}
					{discountSymbool && (
						<span className="price--symbool"> ریال</span>
					)}
				</span>
			)}
			<span>
				{toPersianMoney(children)}
				{symbool && <span className="price--symbool"> ریال</span>}
			</span>
		</span>
	)
}

export default Price
